import {
  useCarrinhoEsvaziar,
  useCarrinhoItemSalvar,
  useCarrinhoSalvar,
} from "./useCarrinhoService";
import CarrinhoContext from "./CarrinhoContext";
import { useContext } from "react";
import {
  CarrinhoDTO,
  CarrinhoProdutoDTO,
  ItemCarrinhoFiltroDTO,
} from "./useCarrinhoReducer";

// const handleEsvaziaCarrinho = () => {
//   const { carrinhoReducer, dispatch } = useContext(CarrinhoContext);

//   useCarrinhoEsvaziar(carrinhoReducer.Codcarrinho!);
//   dispatch({ type: "ESVAZIACARRINHO", CodProduto: produto.CodProduto });
// };

export async function AddProdutoCarrinho(produto: CarrinhoProdutoDTO, carrinho: CarrinhoDTO) {
//   const { carrinhoReducer, dispatch } = useContext(CarrinhoContext);

  //   if (carrinhoReducer.Codcarrinho == 0) {
  const Codcarrinho = useCarrinhoSalvar(carrinho);

  console.log("Codcarrinho: ", Codcarrinho);

  //   }
//   var filtro: ItemCarrinhoFiltroDTO = { Codacerto: Codcarrinho, Codproduto: produto.CodProduto, Desconto: produto.Desconto, Quantidade: produto.Qtd, Vlrunitario: produto.Vlr, }; await useCarrinhoItemSalvar(filtro);

  return produto;

//   dispatch({ type: "ADDPRODUTO", Produto: produto });
}
